import React, {MouseEvent} from 'react'

import {Button} from '../../UI/index.js'

export interface MapControlButtonProps {
    icon: string
    /** The tooltip and the button's accessible name */
    label: string
    /** A mode button: selected and aria-pressed while its mode is on. Leave it out for a button that just acts */
    active?: boolean
    /** No tooltip, e.g. while the button's own popover is open or on a touch screen; the label still names it */
    hideTooltip?: boolean
    disabled?: boolean
    onClick?: (event: MouseEvent<HTMLButtonElement>) => void
}

/** A button in a map's toolbar card (MapControlCard): an icon with its label as tooltip at the right */
export default function MapControlButton({icon, label, active, hideTooltip, disabled, onClick}: MapControlButtonProps) {
    return (
        <Button
            variant='text'
            icon={icon}
            tooltip={hideTooltip ? undefined : label}
            tooltipPlacement='right'
            aria-label={label}
            selected={active}
            aria-pressed={active}
            disabled={disabled}
            onClick={onClick}
        />
    )
}
